import { useTrackingEventsDatasNoItems } from "@/hooks";
import { useTrackingEvent } from "./useTrackingEvent";
export const useTrackingLeadFormError = () => {
    const EVENT_DATA = Object.assign(Object.assign({}, useTrackingEventsDatasNoItems(true)), { event: "form_error", av_feature: "lead_classified_form" });
    return useTrackingEvent(EVENT_DATA);
};
